var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAiAssistant({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,9l1.25-2.75,2.75-1.25-2.75-1.25-1.25-2.75-1.25,2.75-2.75,1.25,2.75,1.25,1.25,2.75ZM11.5,9.5l-2.5-5.5-2.5,5.5-5.5,2.5,5.5,2.5,2.5,5.5,2.5-5.5,5.5-2.5-5.5-2.5ZM19,15l-1.25,2.75-2.75,1.25,2.75,1.25,1.25,2.75,1.25-2.75,2.75-1.25-2.75-1.25-1.25-2.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAiAssistant);
export default __webpack_public_path__ + "static/media/Icon_AIAssistant.9088514784e90d169de347c2685e7c5f.svg";
export { ForwardRef as ReactComponent };